// Centralized React Query key factory. Every useQuery / queryClient.* call
// must reference these — never freehand array keys. This is the single biggest
// cache-bug preventer in the funnel.

export const qk = {
  diagnosis: (id: string) => ["diagnosis", id] as const,
  diagnosisLatest: () => ["diagnosis", "latest"] as const,
  packDetail: (id: string) => ["pack", id] as const,
  packStartState: (id: string) => ["pack", id, "start-state"] as const,
  packActiveSession: (id: string) => ["pack", id, "active-session"] as const,
  entitlements: () => ["me", "entitlements"] as const,
  me: () => ["me"] as const,
  freeTrainingResult: (groupId: number) =>
    ["free-training", "result", groupId] as const,

  // Phase 8 additions — learning state, coach, orders.
  progress: () => ["me", "progress"] as const,
  stats: () => ["me", "stats"] as const,
  mastery: () => ["me", "mastery"] as const,
  learningPreferences: () => ["me", "learning-preferences"] as const,
  weaknesses: () => ["me", "weaknesses"] as const,
  srsDue: () => ["me", "srs", "due"] as const,
  coachToday: () => ["me", "coach", "today"] as const,
  dailyMissionToday: () => ["daily-mission", "today"] as const,
  orders: () => ["me", "orders"] as const,
  achievements: () => ["me", "achievements"] as const,
} as const;
